import * as React from 'react';
import classnames from 'classnames';
import styles from './GeofenceSettings.module.css';

interface GeofenceSettingsProps {
  show: boolean;
  children: React.ReactNode;
}

const GeofenceSettings: React.FC<GeofenceSettingsProps> = ({
  children,
  show,
}) => {
  return (
    <div
      className={classnames(styles.GeofenceSettings, { [styles.Show]: show })}
    >
      {children}
    </div>
  );
};

export default GeofenceSettings;
